var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(" SINGLE EXPERIENCE MANAGER ")
      ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_form.title.$error } },
        [
          _c("label", [_vm._v(" Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Title" },
            model: {
              value: _vm.$v.data_form.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.title, "$model", $$v)
              },
              expression: "$v.data_form.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_form.form_ui.$error } },
        [
          _c("label", [_vm._v(" Select Experience Manager")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsFormUI,
              "is-async": true,
              "cache-option": false,
              placeholder: "Select Experience Manager",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_form.form_ui.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.form_ui, "$model", $$v)
              },
              expression: "$v.data_form.form_ui.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_form.selected_view.$error } },
        [
          _c("label", [_vm._v(" Select Primary View (Web) ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.list_view,
              label: "name",
              "value-format": "object",
              placeholder: "Select View (Web)"
            },
            model: {
              value: _vm.$v.data_form.selected_view.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.selected_view, "$model", $$v)
              },
              expression: "$v.data_form.selected_view.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          class: { "error-input": _vm.$v.data_form.selected_view_small.$error }
        },
        [
          _c("label", [_vm._v(" Select Primary View (Mobile) ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.list_view_small,
              label: "name",
              "value-format": "object",
              placeholder: "Select View (Mobile)"
            },
            model: {
              value: _vm.$v.data_form.selected_view_small.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_form.selected_view_small, "$model", $$v)
              },
              expression: "$v.data_form.selected_view_small.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeForm }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveForm } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-847884ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-847884ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jFormUiSetup.vue
// module id = null
// module chunks = 